import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { Map } from 'immutable';
import ReduxRecord from './reduxRecord';
import _Item from './Item';
import _Stimulus from './Stimulus';
import { TEMPORARY_ITEM_ID, TEMPORARY_STIMULUS_ID } from '@instructure/quiz-common';
export var BankEntry = /*#__PURE__*/function (_ReduxRecord) {
  function BankEntry() {
    _classCallCheck(this, BankEntry);
    return _callSuper(this, BankEntry, arguments);
  }
  _inherits(BankEntry, _ReduxRecord);
  return _createClass(BankEntry, [{
    key: "getEntry",
    value: function getEntry() {
      var _this2 = this;
      if (this.entry === TEMPORARY_ITEM_ID) {
        return _Item.create(this.getState().getIn(['modifications', 'items', TEMPORARY_ITEM_ID]));
      }
      if (this.entry === TEMPORARY_STIMULUS_ID) {
        return _Stimulus.create(this.getState().getIn(['modifications', 'stimuli', TEMPORARY_STIMULUS_ID]));
      }
      var entryCreator = {
        Item: function Item() {
          return _Item.create(_this2.getState().getIn(['items', _this2.entry.get('id')]));
        },
        Stimulus: function Stimulus() {
          return _Stimulus.create(_this2.getState().getIn(['stimuli', _this2.entry.get('id')]));
        }
      }[this.entryType];
      if (entryCreator) return entryCreator();
    }
  }, {
    key: "getNestedEntries",
    value: function getNestedEntries() {
      var entry = this.getEntry();
      var getNestedEntriesFunction = {
        Item: function Item() {
          return [entry];
        }
      }[this.entryType];
      if (getNestedEntriesFunction) return getNestedEntriesFunction();
    }
  }, {
    key: "getWorkingInstance",
    value: function getWorkingInstance() {
      return this.merge(this.getState().getIn(['modifications', 'bankEntries', this.id]));
    }
  }, {
    key: "isStimulus",
    get: function get() {
      var _this$getEntry;
      return this.entryType === 'Stimulus' && !((_this$getEntry = this.getEntry()) !== null && _this$getEntry !== void 0 && _this$getEntry.isPassage);
    }
  }, {
    key: "isPassage",
    get: function get() {
      var _this$getEntry2;
      if (!this.isStimulus) return false;
      return (_this$getEntry2 = this.getEntry()) === null || _this$getEntry2 === void 0 ? void 0 : _this$getEntry2.isPassage;
    }
  }, {
    key: "isStimulusEntry",
    get: function get() {
      var entry = this.getEntry();
      if (!entry) return false;
      return entry.isStimulus && !entry.isPassage;
    }
  }, {
    key: "isPassageEntry",
    get: function get() {
      var entry = this.getEntry();
      if (!entry) return false;
      return entry.isStimulus && entry.isPassage;
    }
  }]);
}(ReduxRecord({
  id: '0',
  entry: Map(),
  bankId: '0',
  archived: false,
  entryType: null,
  createdAt: null,
  updatedAt: null
}));
export default BankEntry;